<template>
  <div class="timer"><h3>:{{ this.$store.state.timerTime }}</h3></div>
</template>

<script>
import eventBus from '@/eventBus'

export default {
  name: 'Timer',
  props: {
    time: String
  },
  data() {
    return {
      timerTime: this.$store.state.timerTime
    }
  },
  beforeMount() {
    this.$store.dispatch('setTimer', this.time)
  },
  beforeDestroy() {
    eventBus.$off('reset-timer')
  },
  mounted() {
    this.$store.dispatch('setTimer', this.time)
    let timerInterval = setInterval(() => {
      if(this.$store.state.timerTime > 0) {
        this.$store.dispatch('updateTimer', 1)
      } else {
        clearInterval(timerInterval)
        eventBus.$emit("timer-done")
      }
    }, 1000)

    eventBus.$on('reset-timer', () => {
      clearInterval(timerInterval)
    })
  }
}
</script>

<style scoped>
  .timer {
    background: url('../assets/timer_bg.png') top center no-repeat;
    height: 210px;
    position: absolute;
    left: 50%;
    margin-bottom: 50px;
    top: 0;
    transform: translateX(-50%);
    width:279px;
    z-index: 2;
  }

  h3 {
    bottom:40px;
    color: #fff;
    font-size: 62px;
    font-weight: 900;
    left: 50%;
    margin: 0;
    position: absolute;
    transform: translateX(-50%);
  }
</style>